// extracted by mini-css-extract-plugin
module.exports = {"optgroup":"optgroup_optgroup__2x9K7","label":"optgroup_label__1oAxp","s":"optgroup_s__LrGsh","m":"optgroup_m__1W2i9","l":"optgroup_l__clQC4","xl":"optgroup_xl__5ZjLV"};